<div class="structure-node-selection" [formGroup]="strcutureSelectionFormGroup">

  <mat-form-field class="structure-node-selection-field" appearance="fill">
    <mat-label>
      <sc-dictionary-label dictionaryKey="shared.structure-node-selection.label"></sc-dictionary-label>
    </mat-label>
    <mat-select name="structureNode" formControlName="structureNode">
      @for (o of structureNodes; track o) {
        <mat-option [value]="o">
          @if (o.stationGroupId == null && o.stationSetId != null) {
            &nbsp;&nbsp;
          }
          {{o.name}}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
</div>
